import styled from 'styled-components';
import { merriweather } from 'styles/GlobalStyle';

const ImageCaption = styled.span`
    position: absolute;
    bottom: 7px;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 5px 10px;
    font-size: 12px;
    font-family: ${merriweather.style.fontFamily};
`;

export default ImageCaption;
